/**
 * Carrinho (drawer + /cart): força país Brasil e estado padrão no estimador de frete,
 * já que o cálculo usa apenas CEP. Complementa o CSS que oculta os selects.
 */
(function () {
  var BRAZIL = 'Brazil';
  var PROVINCE_PREFS = ['São Paulo', 'SP', 'Sao Paulo'];

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function isCartShippingCalculator(el) {
    return !!(el.closest && (el.closest('#CartDrawer') || el.closest('#hdt-page-cart')));
  }

  function pickProvinceValue(provinceSel) {
    if (!provinceSel || provinceSel.options.length < 2) return null;
    var opts = Array.from(provinceSel.options);
    var pi;
    for (pi = 0; pi < PROVINCE_PREFS.length; pi++) {
      var p = PROVINCE_PREFS[pi];
      if (opts.some(function (o) { return o.value === p; })) return p;
    }
    var first = opts.find(function (o) {
      return o.value && !o.disabled;
    });
    return first ? first.value : null;
  }

  function syncCalculator(host) {
    var country = host.querySelector('select[name="address[country]"]');
    var province = host.querySelector('select[name="address[province]"]');
    if (!country || !province) return;

    function applyProvince() {
      var v = pickProvinceValue(province);
      if (v && province.value !== v) {
        province.value = v;
        province.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (country.value !== BRAZIL) {
      country.value = BRAZIL;
      country.dispatchEvent(new Event('change', { bubbles: true }));
      queueMicrotask(applyProvince);
      setTimeout(applyProvince, 50);
      setTimeout(applyProvince, 200);
      setTimeout(applyProvince, 600);
    } else {
      applyProvince();
    }
  }

  function syncAll() {
    document.querySelectorAll('hdt-shipping-calculator').forEach(function (calc) {
      if (isCartShippingCalculator(calc)) syncCalculator(calc);
    });
  }

  function stripRateLocationHints() {
    var re = /São Paulo,\s*Brazil,?/gi;
    document.querySelectorAll('.hdt-mess__rates, .hdt-response__rates').forEach(function (el) {
      if (!el.innerHTML || el.innerHTML.indexOf('São Paulo') === -1) return;
      el.innerHTML = el.innerHTML.replace(re, '');
    });
  }

  function run() {
    syncAll();
    stripRateLocationHints();
  }

  var debouncedRun = debounce(run, 120);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('cart:reload', function () {
    setTimeout(run, 0);
    setTimeout(run, 350);
  });

  if (!document.body) return;

  try {
    new MutationObserver(debouncedRun).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
